import React, { Component } from 'react';
import { ROOT_DIR } from '../../utils/Constants';
import { Link } from 'react-router-dom';

class PriorityListItems extends Component {
  
  render(){
    let list = this.props.priorityList;
    //let typeDir = this.props.typeDir;
    return(
      <div className="results">
        <ul className="results-list priority">
          { list.map((item, idx) => (
          <li key={idx}>
            <div className="listing-logo-wrapper">
              <Link to={`/pdetails/${item.id}`}><img src={`${ROOT_DIR}/assets/img/logos/bus${item.id}.jpg`}/></Link>
            </div>
            <div className="listing-info-wrapper">
              <h3 className="results-title no-margin"><Link to={`/pdetails/${item.id}`}>{item.name}</Link></h3>
              <div className="priority-social">
                {item.facebook && 
                  <a href={item.facebook} className="social-facebook" target="_blank"><i className="fa fa-facebook-official fa-2x" aria-hidden="true"></i></a>
                }
                {item.twitter &&
                  <a href={item.twitter} className="social-twitter" target="_blank"><i className="fa fa-twitter-square fa-2x" aria-hidden="true"></i></a>
                }

              </div>
              <p>{item.address} {item.address && item.city && ','} {item.city}</p>
            </div>
            
          </li>
          
          ))
          }
          <li className="priority-promo">
            <Link to="/getfound"><img src={`${ROOT_DIR}/assets/img/logo-icon-sm.png`}/>Want your listing here at the top?</Link>
          </li>
        </ul>
      </div>
    );
  }
}
export default PriorityListItems;


// WEBPACK FOOTER //
// ./src/components/blocks/PriorityListItems.js